import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'frontbucket.search.results.optInError.title',
    description: 'Title of a flag shown when opting in to search failed',
    defaultMessage: `Whoops, we couldn't enable search.`,
  },
  description: {
    id: 'frontbucket.search.results.optInError.description',
    description: 'Description of a flag shown when opting in to search failed',
    defaultMessage: `Try again shortly. If you still can't enable search, contact {support}.`,
  },
});
